import logo from './logo.svg';
import './App.css';
import ReactSlider from 'react-slider'
import styled from 'styled-components';
import { ReporteService } from './ReporteService';
import { useEffect, useState, useRef } from 'react';
import { AppBar, Avatar, Button, Divider, Grid, IconButton, Toolbar } from '@material-ui/core';
import Container from '@material-ui/core/Container';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import InfoIcon from '@material-ui/icons/Info';
import Switch from '@material-ui/core/Switch';

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: 300,
    minHeight: 400
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontFamily: "'Roboto', sans-serif",
    fontSize: 14,
  },
  title_person: {
    fontFamily: "'Roboto', sans-serif",
    fontSize: 16,
  },
  large: {
    width: theme.spacing(14),
    height: theme.spacing(14),
  },
  namePerson: {
    fontSize: 13,
    fontFamily: "'Roboto', sans-serif",
    marginLeft: 4,
    marginBottom: 4
  },
  votosText: {
    fontSize: 13,
    fontFamily: "'Roboto', sans-serif",
    marginLeft: 4,
    marginBottom: 4
  },
  pos: {
    margin: 8,
  },
  gridContainer: {
    marginTop: 8
  },
  textParrafo: {
    fontSize: 16,
    fontFamily: "'Roboto', sans-serif",
    margin: 20,
    fontWeight: 550
  }

}));
function App() {




  const mediaMatch = window.matchMedia('(min-width: 500px)');
  const [matches, setMatches] = useState(mediaMatch.matches);

  useEffect(() => {
    const handler = e => setMatches(e.matches);
    mediaMatch.addListener(handler);
    return () => mediaMatch.removeListener(handler);
  });

  const [dataOriginal, setDataOriginal] = useState(null);
  const [data, setData] = useState(null);
  const [dataK, setDataK] = useState({});
  const [dataPC, setDataPC] = useState({});
  const [isSticky, setIsSticky] = useState(false);
  const stickyRef = useRef(null);
  const [sumK, setSumK] = useState(0);
  const [sumPC, setSumPC] = useState(0);

  const [dataCandidatos, setDataCandidatos] = useState([]);

  const StyledSlider = styled(ReactSlider)`
width: 100%;
height: 25px;
`;

  const StyledThumb = styled.div`
height: 25px;
line-height: 25px;
width: 25px;
text-align: center;
background-color: black;
color: #fff;
border-radius: 50%;
cursor: grab;
`;

  const Thumb = (props, state) => <StyledThumb {...props}></StyledThumb>;

  const StyledTrack = styled.div`
top: 0;
bottom: 0;
background: ${props => props.index === 2 ? '#91B38F' : props.index === 1 ? '#EBA36C' : '#ddd'};
border-radius: 999px;
`;

  const Track = (props, state) => <StyledTrack {...props} index={state.index} />;
  const classes = useStyles();
  const bull = <span className={classes.bullet}>•</span>;
  function formatNumber(num) {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
  }

  function formatPercent(num) {
    //let value = Math.round((num * 100) / total);
    return num.toString() + "%"
  }

  const calcularData = () => {

    let sumK = 0;
    let sumPC = 0;
    dataCandidatos.forEach(element => {
      sumK = sumK + element.votosK;
      sumPC = sumPC + element.votosPC;
    });

    //console.log('sumK', sumK);
    //console.log('sumPC', sumPC);
    setSumK(sumK);
    setSumPC(sumPC);
  }

  const handleChange = (val, cod) => {
    let _arr = [...dataCandidatos];

    const data = _arr.find(r => r.cod === cod);
    const index = _arr.findIndex(r => r.cod === cod);
    data.votosNN = val[0];
    data.ind = val[1];
    _arr[index] = data;

    console.log("dataCandidatos", _arr);
    setDataCandidatos(_arr);
    calcularData();

  }



  const [stateViewData, setStateViewData] = useState(false);
  const handleChangeSwitch = (event) => {
    setStateViewData(event.target.checked);
  };
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (!stickyRef.current) return;
  
      const top = stickyRef.current.getBoundingClientRect().top;
  
      // cuando llega al top (0 o menos)
      setIsSticky(top <= 0);
    };
  
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    let firstOpen = localStorage.getItem("first_open");

    if (firstOpen === null) {
      setOpen(true);
      localStorage.setItem("first_open", 1);
    }
    const service = new ReporteService();
    service.getInfo().then((res) => {
      setDataOriginal(res);
    });
    service.get2026().then((res) => {
      console.log(res);
      let results = res.data;

      //console.log(res);


      setDataK(results.find(r => r.codigoAgrupacionPolitica === "8"));
      setDataPC(results.find(r => r.codigoAgrupacionPolitica === "10"));


      let arr = results.filter(r => (r.codigoAgrupacionPolitica != null && r.codigoAgrupacionPolitica !== "8" && r.codigoAgrupacionPolitica !== "10"));
      let candidatos = [];
      arr.forEach(element => {

        if (element.codigoAgrupacionPolitica != null) {
          candidatos.push({ cod: element.codigoAgrupacionPolitica, total: 0, votosK: 0, votosPC: 0, votosNN: 0, ind: 50 });
        }

      });
      setData(arr);
      setDataCandidatos(candidatos);
    });
  }, []);

  const frame = (dataK, img, isWin,colors, sum) => {
    return (
      <CardContent style={{ color: '#003770' }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          marginBottom: 10
        }}>
          <img
            src={`https://resultadoelectoral.onpe.gob.pe/assets/img-reales/partidos/${img}.jpg`}
            alt={dataK?.nombreAgrupacionPolitica}
            style={{
              width: 30,
              height: 30,
              borderRadius: '50%',
              objectFit: 'cover',
              border: '2px solid #ddd'
            }}
          />
          <Typography variant="h6" style={{ fontWeight: '400' }}>
            {dataK?.nombreAgrupacionPolitica}
          </Typography>

        </div>
        <Divider light />
        <Typography className={classes.pos} color="textSecondary">
        <img
          alt={dataK?.nombreAgrupacionPolitica}
          style={{
            width: 100,
            height: 100,
            borderRadius: '50%',
            objectFit: 'cover',
            border: '2px solid #ddd'
          }}
          src={`https://resultadoelectoral.onpe.gob.pe/assets/img-reales/candidatos/${dataK.dniCandidato}.jpg`}></img>

      </Typography>
        <Typography className={classes.title_person} gutterBottom>
          {dataK?.nombreCandidato}
        </Typography>

        <Typography variant="body2" component="p">
          Votos 1ra vuelta
        </Typography>
        <Typography style={{ fontWeight: 600, fontSize: 25 }}>
          {formatNumber(dataK.totalVotosValidos)}
        </Typography>
        <Typography variant="body2" component="p">
          Simulación de 2da vuelta
        </Typography>
        <Typography style={{ fontWeight: 600, fontSize: 25 }}>
          {formatNumber(sum || 0)}
        </Typography>
        <div style={{ marginTop: 20 }}>
          <Divider light />
          <div
            style={{
              marginTop: 20,
              borderRadius: 12,
              overflow: 'hidden',
              boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
              textAlign: 'center'
            }}
          >
            <div
              style={{
                background: isWin ? `linear-gradient(90deg,${colors[0]}, ${colors[1]})` : 'linear-gradient(90deg, #9CA3AF, #E5E7EB)',
                padding: '10px 0',
                fontWeight: 700,
                fontSize: 20,
                color: '#2e5f2e',
                letterSpacing: 1
              }}
            ></div>

            <div
              style={{
                background: isWin ? colors[1] : '#E5E7EB',
                padding: '12px 0',
                fontSize: 16
              }}>
              Total de votos:
              <div style={{ fontSize: 22, fontWeight: 700 }}>
                {formatNumber(dataK.totalVotosValidos + sum)}
              </div>
            </div>
          </div>
        </div>
      </CardContent>
    );
  }

  const frameMin = (dataK, img, isWin,colors, sum) => {
    return (
      <CardContent style={{ color: '#003770' }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          marginBottom: 10
        }}>
          <img
            src={`https://resultadoelectoral.onpe.gob.pe/assets/img-reales/partidos/${img}.jpg`}
            alt={dataK?.nombreAgrupacionPolitica}
            style={{
              width: 30,
              height: 30,
              borderRadius: '50%',
              objectFit: 'cover',
              border: '2px solid #ddd'
            }}
          />
          <Typography variant="h6" style={{ fontWeight: '400' }}>
            {dataK?.nombreAgrupacionPolitica}
          </Typography>

        </div>
        <Divider light />
       
        

        <Typography variant="body2" component="p">
          Votos 1ra vuelta
        </Typography>
        <Typography style={{ fontWeight: 600, fontSize: 25 }}>
          {formatNumber(dataK.totalVotosValidos)}
        </Typography>
      
        <div style={{ marginTop: 20 }}>
          <div
            style={{
              marginTop: 20,
              borderRadius: 12,
              overflow: 'hidden',
              boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
              textAlign: 'center'
            }}
          >
            <div
              style={{
                background: isWin ? `linear-gradient(90deg,${colors[0]}, ${colors[1]})` : 'linear-gradient(90deg, #9CA3AF, #E5E7EB)',
                padding: '10px 0',
                fontWeight: 700,
                fontSize: 20,
                color: '#2e5f2e',
                letterSpacing: 1
              }}
            ></div>

            <div
              style={{
                background: isWin ? colors[1] : '#E5E7EB',
                padding: '12px 0',
                fontSize: 16
              }}>
              Total de votos:
              <div style={{ fontSize: 22, fontWeight: 700 }}>
                {formatNumber(dataK.totalVotosValidos + sumK)}
              </div>
            </div>
          </div>
        </div>
      </CardContent>
    );
  }
  return (
    <>
      <AppBar position="static">
        <Toolbar >

          <Typography style={{ flexGrow: 1 }} variant="h6" className={classes.title}>
            SIMULADOR ELECTORAL 2026 - SEGUNDA VUELTA
          </Typography>


          <IconButton color="inherit" onClick={handleClickOpen}>
            <InfoIcon></InfoIcon>
          </IconButton>

        </Toolbar>
      </AppBar>
      <Container maxWidth="ls" style={{ padding: 10 }}>
        <div className="App">

          {data &&
            <>


<Grid
container
direction="row"
justify="center"
alignItems="baseline"
>

<Card style={{ margin: 20,  minWidth:350, backgroundColor: '#F6F5F5', 
  color: '#003770;',
  opacity: '-moz-initial' }} className={classes.root}>
  {frame(dataK, `00000008`,
    (dataPC.totalVotosValidos + sumPC < (dataK.totalVotosValidos + sumK)&& sumK + sumPC > 0),
    ['#EBA36C','#FFE0B2'], sumK
  )
    }
</Card>
<Card style={{ margin: 20, minWidth:350, backgroundColor: '#F6F5F5', opacity: '-moz-initial' }} className={classes.root}>
  {frame(dataPC, `00000010`, 
     (dataPC?.totalVotosValidos + sumPC > (dataK?.totalVotosValidos + sumK)&& sumK + sumPC > 0),  
    ['#7FAF7C','#CDE7CB']
    , sumPC
    )}
</Card>
</Grid>
                
             
             

            
              <Divider light />
              <div className={classes.textParrafo}>
                <p>Para analizar los votos en porcetanje, active la siguiente opción:</p>
                <Grid component="label" container alignItems="center"
                  justify="center" spacing={1}>
                  <Grid item>Números</Grid>
                  <Grid item>
                    <Switch
                      checked={stateViewData}
                      onChange={handleChangeSwitch}
                      name="checkedA"
                      color="primary"
                      inputProps={{ 'aria-label': 'secondary checkbox' }}
                    />
                  </Grid>
                  <Grid item>Porcentaje</Grid>
                </Grid>
                <Divider light />
              </div>
              <Grid
                container
                direction="row"
                justify="center"
                alignItems="center"
                style={{ marginTop: 20 }}
              >
                {data.sort(function (a, b) {
                  if (a.TOTAL_VOTOS > b.TOTAL_VOTOS) {
                    return 1;
                  }
                  if (a.TOTAL_VOTOS < b.TOTAL_VOTOS) {
                    return -1;
                  }
                  // a must be equal to b
                  return 0;
                }).map((obj) => {
                  let dataC = dataCandidatos.find(r => r.cod === obj.codigoAgrupacionPolitica);
                  let nuevoTotal = 0;
                  let votosK = 0;
                  let votosPC = 0;
                  let votosNN = 0;
                  let totalVotos = 0;
                  let porcK, porcPC = 0;
                  if (dataC != null) {
                    totalVotos = obj.totalVotosValidos;


                    votosNN = Math.round(totalVotos * (dataC.votosNN / 100));
                    //console.log("totalVotos", totalVotos);
                    //console.log("dataC.votosNN", dataC.votosNN);
                    //console.log("votosNN", votosNN)
                    //console.log("votdataC.indosNN", dataC.ind)

                    // (totalVotos - votosNN)
                    porcK = dataC.ind - dataC.votosNN;
                    porcPC = 100 - dataC.ind;

                    nuevoTotal = totalVotos;// - votosNN;//totalVotos - Math.round(votosNN * (dataC.votosNN / 100));
                    //console.log("nuevoTotal", nuevoTotal)
                    votosK = Math.round(nuevoTotal * (porcK / 100));
                    //console.log("votosK", votosK)
                    //console.log("porcK", porcK)
                    votosPC = Math.round(nuevoTotal * (porcPC / 100));
                    //console.log("votosPC", votosPC)
                    //console.log("porcPC", porcPC)
                    dataC.votosK = votosK;
                    dataC.votosPC = votosPC;



                  }
                  return (

                    <div style={{ width: matches ? '50%' : '100%' }}>
                      {dataC &&
                        <>
                          {/*
                          <Card className={classes.root}>
                            <CardContent>
                              <CircularSlider
                                label="Votos"
                                width={200}
                                min={0}
                                max={totalVotos}
                                dataIndex={100}
                                prependToValue=""
                                appendToValue=""
                                labelColor="#005a58"
                                labelBottom={true}
                                knobColor="#005a58"
                                knobSize={40}
                                data={[formatNumber(totalVotos)]}
                                progressColorFrom="#EBA36C"
                                progressColorTo="#EBA36C"
                                progressSize={12}
                                trackColor="#DF6966"
                                trackSize={12}
                              >

                              </CircularSlider>
                            </CardContent>
                          </Card>

*/}

                          <Grid
                            container
                            direction="row"
                            justify="space-between"
                            alignItems="center"
                            className={classes.gridContainer}
                          >

                            <Grid item>
                              <Avatar alt="Remy Sharp" src={`https://resultadoelectoral.onpe.gob.pe/assets/img-reales/candidatos/${obj.dniCandidato}.jpg`} />
                            </Grid>
                            <Grid item xs={12} ls={12} sm container>
                              <Grid item xs container justify="space-between"
                                alignItems="center" direction="row">
                                <Grid item >
                                  <span alignItems="center" className={classes.namePerson}>{obj.nombreAgrupacionPolitica.trim()}</span>
                                </Grid>
                                <Grid item style={{ marginRight: 50 }} >
                                  <span style={{ fontWeight: '700' }} className={classes.namePerson} >Total de votos {formatNumber(obj.totalVotosValidos)}</span>
                                </Grid>
                              </Grid>
                            </Grid>
                            <Grid item>
                            </Grid>
                          </Grid>

                          <div style={{ width: '90%', marginTop: 5, margin: 'auto' }}>
                            <StyledSlider onAfterChange={val => handleChange(val, obj.codigoAgrupacionPolitica)}
                              defaultValue={[dataC.votosNN, dataC.ind]}
                              renderTrack={Track}
                              renderThumb={Thumb}
                            />
                          </div>

                          <Grid container spacing={2}>

                            <Grid item xs={12} sm container>
                              <Grid item xs container alignItems="center" direction="column">
                                <Grid item xs>
                                  <span className={classes.votosText}>Votos nulos o blancos</span>
                                </Grid>
                                <Grid item >
                                  {stateViewData ?
                                    <span className={classes.votosText}>  {formatPercent(dataC.votosNN)} </span>
                                    :
                                    <span className={classes.votosText}>  {formatNumber(votosNN)} </span>
                                  }


                                </Grid>
                              </Grid>
                              <Grid item xs container alignItems="center" direction="column" >
                                <Grid item xs>
                                  <span className={classes.votosText}>Fuerza Popular</span>
                                </Grid>
                                <Grid item >
                                  {stateViewData ?
                                    <span className={classes.votosText}>  {formatPercent(porcK)} </span>
                                    :
                                    <span className={classes.votosText}>  {formatNumber(votosK)} </span>
                                  }
                                </Grid>
                              </Grid>
                              <Grid item xs container alignItems="center" direction="column">
                                <Grid item xs>
                                  <span className={classes.votosText}>Juntos por el Perú</span>
                                </Grid>
                                <Grid item >
                                  {stateViewData ?
                                    <span className={classes.votosText}>  {formatPercent(porcPC)} </span>
                                    :
                                    <span className={classes.votosText}>  {formatNumber(votosPC)} </span>
                                  }
                                </Grid>
                              </Grid>

                            </Grid>

                          </Grid>

                        </>
                      }
                    </div>
                  )
                })}
              </Grid>
            </>
          }
        </div>
      </Container>

      <AppBar position="static" style={{ marginTop: 10 }}>
        <Toolbar  >

          <Typography style={{ flexGrow: 1 }} variant="h6" className={classes.title}> Desarrollo por    </Typography>
          Jonatan Aburto

          <IconButton color="inherit" aria-label="delete" onClick={() => { window.open('https://www.linkedin.com/in/jonatanapp/', '_blank'); }}>
            <LinkedInIcon></LinkedInIcon>
          </IconButton>
          Ricardo Rodriguez

          <IconButton color="inherit" aria-label="delete" onClick={() => { window.open('https://www.linkedin.com/in/ricardo-rg/', '_blank'); }}>
            <LinkedInIcon></LinkedInIcon>
          </IconButton>
        </Toolbar>
      </AppBar >
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"¿Cómo funciona el simulador?"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <div>
              Arraste el icono color negro según la cantidad de votos que serán distribuidos.
              <ul>
                <li>El color gris indica la cantidad de posibles votos nulos o viciados.</li>
                <li>El color naranja indica la cantidad de posibles votos dirigidos al candidato de FUERZA POPULAR.</li>
                <li>El color verde indica la cantidad de posibles votos dirigidos al candidato de JUNTOS POR EL PERU.</li>
              </ul>
            </div>
            <div style={{ width: '90%', marginTop: 15, margin: 'auto' }}>
              <StyledSlider
                defaultValue={[33, 66]}
                renderTrack={Track}
                renderThumb={Thumb}
              />
            </div>


            {dataOriginal?.data && (() => {
              const d = dataOriginal.data;

              const contabilizadas = d.actasContabilizadas || 0;
              const enviadas = d.actasEnviadasJee || 0;
              const pendientes = d.actasPendientesJee || 0;

              const fecha = new Date(d.fechaActualizacion).toLocaleString('es-PE');

              return (
                <div style={{ marginTop: 20 }}>

                  {/* Título */}
                  <div style={{ fontWeight: 700, color: '#2a5d9f' }}>
                    Actas contabilizadas
                  </div>

                  {/* Porcentaje + info */}
                  <div style={{ display: 'flex', alignItems: 'center', gap: 15 }}>
                    <div style={{ fontSize: 28, fontWeight: 700 }}>
                      {contabilizadas.toFixed(3)} %
                    </div>

                    <div style={{ fontSize: 13 }}>
                      Total de actas: {d.totalActas.toLocaleString()}
                      <br />
                      {enviadas.toFixed(3)}% enviadas al JEE y {pendientes.toFixed(3)}% pendientes
                    </div>
                  </div>

                  {/* Barra */}
                  <div style={{
                    display: 'flex',
                    height: 10,
                    borderRadius: 10,
                    overflow: 'hidden',
                    marginTop: 8,
                    background: '#eee'
                  }}>
                    <div style={{ width: `${contabilizadas}%`, background: '#0b3c6d' }} />
                    <div style={{ width: `${enviadas}%`, background: '#6faed6' }} />
                    <div style={{ width: `${pendientes}%`, background: '#cfd8dc' }} />
                  </div>

                  {/* Leyenda */}
                  <div style={{
                    display: 'flex',
                    gap: 15,
                    fontSize: 12,
                    marginTop: 8,
                    flexWrap: 'wrap'
                  }}>
                    <span>🔵 Contabilizadas ({d.contabilizadas.toLocaleString()})</span>
                    <span>🔷 JEE ({d.enviadasJee.toLocaleString()})</span>
                    <span>⚪ Pendientes ({d.pendientesJee.toLocaleString()})</span>
                  </div>

                  {/* Fecha */}
                  <div style={{ fontSize: 12, marginTop: 6, color: '#666' }}>
                    Actualizado: {fecha}
                  </div>

                </div>
              );
            })()}
          </DialogContentText>
        </DialogContent>
        <DialogActions>

          <Button onClick={handleClose} color="primary" autoFocus>
            Entendido
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default App;
